import { createContext, useReducer, useEffect, useMemo } from "react";
// firestore
import { query, getDocs, collection } from "firebase/firestore";
import { db } from "../services/firebase";
// products
import actionTypes from "../common/actionTypes";
import { integrationReducer } from "../reducers";
// context
import useAuthContext from "../hooks/useAuthContext";
// constants
import { DATABASE_STATUTES } from "../common/constants";

// Integrations constants
const INTEGRATIONS = "Integrations";

const initialState = {
  data: [],
  status: DATABASE_STATUTES.NOT_LOADED,
  error: null,
};

const IntegrationsContext = createContext({
  ...initialState,
});

const IntegrationsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(integrationReducer, initialState);

  const { user } = useAuthContext();

  useEffect(() => {
    const fetchData = async () => {
      if (user) {
        dispatch({
          type: actionTypes.FETCH_INTEGRATIONS_DATA,
        });

        try {
          const data = [];

          const documentSnapshots = await getDocs(query(collection(db, INTEGRATIONS)));

          documentSnapshots.forEach((doc) => {
            data.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          dispatch({
            type: actionTypes.FETCH_INTEGRATIONS_DATA_SUCCESS,
            payload: data,
          });
        } catch (error) {
          dispatch({
            type: actionTypes.FETCH_INTEGRATIONS_DATA_FAILURE,
            payload: error,
          });
        }
      }
    };

    fetchData();
  }, [user]);

  const memoizedState = useMemo(() => state, [state]);

  return <IntegrationsContext.Provider value={memoizedState}>{children}</IntegrationsContext.Provider>;
};

export { IntegrationsContext, IntegrationsProvider };
